import type { FC, SVGProps } from "react";

const SubtitleIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="subtitle video icon">
      {/* <title>subtitle video icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.53332 2.39999C3.35512 2.39999 2.39999 3.35512 2.39999 4.53332V19.4667C2.39999 20.6449 3.35512 21.6 4.53332 21.6H19.4667C20.6449 21.6 21.6 20.6449 21.6 19.4667V4.53332C21.6 3.35512 20.6449 2.39999 19.4667 2.39999H4.53332ZM5.59999 14.4C5.59999 13.9582 5.95816 13.6 6.39999 13.6H13.3333C13.7752 13.6 14.1333 13.9582 14.1333 14.4C14.1333 14.8418 13.7752 15.2 13.3333 15.2H6.39999C5.95816 15.2 5.59999 14.8418 5.59999 14.4ZM16.2667 14.4C16.2667 13.9582 16.6248 13.6 17.0667 13.6H17.6C18.0418 13.6 18.4 13.9582 18.4 14.4C18.4 14.8418 18.0418 15.2 17.6 15.2H17.0667C16.6248 15.2 16.2667 14.8418 16.2667 14.4ZM9.86666 17.6C9.86666 17.1582 10.2248 16.8 10.6667 16.8H17.6C18.0418 16.8 18.4 17.1582 18.4 17.6C18.4 18.0418 18.0418 18.4 17.6 18.4H10.6667C10.2248 18.4 9.86666 18.0418 9.86666 17.6ZM5.59999 17.6C5.59999 17.1582 5.95816 16.8 6.39999 16.8H6.93332C7.37515 16.8 7.73332 17.1582 7.73332 17.6C7.73332 18.0418 7.37515 18.4 6.93332 18.4H6.39999C5.95816 18.4 5.59999 18.0418 5.59999 17.6Z"
        fill="white"
      />
    </svg>
  );
};

export default SubtitleIcon;
